// NOTE: errors thrown by https://github.com/sampension/react-native-sensitive-info
export const isAuthCanceledError = ({ message, code }) =>
  message === 'Godkendelse annulleret.' || message === 'Canceled by user.' || code === '13';

export const isAuthFailedOnClientError = (err) => err.code === '7';

export const isBiometricsInvalidated = (err) => err.type === 'invalidated';
